import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UnifiedService } from '../unified.service';
import { Router } from '@angular/router';
import { IUnifiedIntegration } from '../unified.types';
import { environment } from "src/environments/environment";
import { AegisIntegrationService } from 'src/app/_services/aegisIntegration.service';

@Component({
    selector: 'app-integration-unit',
    templateUrl: './integration-unit.component.html',
    styleUrls: ['./integration-unit.component.scss'],
    standalone: false
})
export class IntegrationUnitComponent implements OnInit {

  @Input() integration: IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, can_connect: boolean };
  @Output() update: EventEmitter<{ state: 'connected' | 'disconnected' | 'already_connected', integration: IUnifiedIntegration }> = new EventEmitter();
  @Input() isAtsConnected: boolean;

  fetchInProgress: boolean = false;

  constructor(private unifiedService: UnifiedService, private router: Router, private aegisIntegrationService: AegisIntegrationService) { }

  ngOnInit() {
  }

  redirectToAuthUrl() {
    this.fetchInProgress = true;
    this.unifiedService.getUnifiedIntegrationRedirectUrl(this.integration.id).subscribe(response => {
      this.fetchInProgress = false;
      if (response.status === 'success') {
        window.location.href = response.data;
      } else {
        console.error(response.error);
      }
    });
  }

  disconnectIntegration() {
    this.fetchInProgress = true;
    this.unifiedService.disableUnifiedIntegration(this.integration.id).subscribe(response => {
      this.fetchInProgress = false;
      if (response.status === 'success') {
        this.integration.user = null;
        this.update.emit({ state: 'disconnected', integration: this.integration });
      } else {
        console.error(response.error);
      }
    });
  }

  /**
   * Redirects the user to the Aegis authorization URL for authentication and integration setup.
   */
  redirectToAegisAuthUrl() {

    if (this.isAtsConnected) {
      this.update.emit({ state: 'already_connected', integration: this.integration });
    } else {
      window.location.href = `${environment.aegisFrontendUrl}/authorize?clientid=${environment.aegisClientId}&redirecturi=${encodeURIComponent(environment.frontendurl + '/settings/ats-integrations/ats')}`;
    };
  };

  /**
   * Disconnects the Aegis integration by calling the AegisIntegrationService to disconnect and then updates the integration state accordingly.
   */
  disconnectAegisIntegration() {
    this.fetchInProgress = true;
    this.aegisIntegrationService.disconnectAegisIntegration(this.integration.id).subscribe((response: any) => {
      this.fetchInProgress = false;
      if (response && response.body && response.body?.success) {
        this.integration.user = null;
        this.update.emit({ state: 'disconnected', integration: this.integration });
      } else {
        console.error(response.body?.error);
      }
    }, (error) => {
      this.fetchInProgress = false;
      console.error('Error disconnecting Aegis integration:', error);
    });
  };
}
